import { UserFullInfo, UserWoman } from "@/types/user";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../lib/firebaseConfig";

//　レコメンド対象になっているか確認する関数
export const listenIsAvailableRecommend = async (uid: string, setter: any) => {
  // console.log("[Enter] listenIsAvailableRecommend");
  // ref: https://firebase.google.cn/docs/firestore/query-data/queries?hl=ja#execute_a_query
  const q = query(collection(db, "UserMen"), where("uid", "==", uid));
  const querySnapshot = await getDocs(q);
  const check = await valueCheck(querySnapshot.docs[0].data());
  // console.log("check", check);
  setter(check);
  return check;
};

export const REQUIRED_FIELDS_MAN: (keyof UserFullInfo)[] = [
  "location",
  "bodyShape",
  "age",
  "height",
  "fella",
  "cunnilingus",
  "kubishime",
  "mildWordsBlame",
  "hardWordsBlame",
  "spanking",
  "outdoorPlay",
  "spouting",
  "deepThroating",
  "cosplay",
  "sLevel",
  "mLevel",
  "multi",
  "anal",
  "exchangePhotoBeforeMeet",
  "takePhoto",
  "experiencedPeopleNum",
  "appealDetail",
  "seihekiDetail"
];

const isEmptyValue = (value: any): boolean => {
  return value === undefined || value === "";
};

export const valueCheck = async (
  manDoc: Partial<UserFullInfo>
): Promise<boolean> => {
  // Special check for availableDate fields
  const hasValidAvailableDate =
    !isEmptyValue(manDoc.availableDateList) ||
    !isEmptyValue(manDoc.availableDate);

  if (!hasValidAvailableDate) {
    return false;
  }

  // Check all required fields
  return REQUIRED_FIELDS_MAN.every((field) => {
    if (!isEmptyValue(manDoc[field])) return field;
    else {
      console.log(field, manDoc[field]);
    }
  });
};

export const REQUIRED_FIELDS_WOMEN: (keyof UserWoman)[] = [
  "desired_age",
  "desired_anal",
  "desired_appeal",
  "desired_attribute",
  "desired_bodyShape",
  "desired_call_before_meet",
  "desired_cosplay",
  "desired_cunnilingus",
  "desired_dm_before_meet",
  "desired_exchange_contact_before_meet",
  "desired_exchange_photo_before_meet",
  "desired_experiencedPeople",
  "desired_fella",
  "desired_hardWordsBlame",
  "desired_hasCar",
  "desired_height",
  "desired_kamiato",
  "desired_kousoku",
  "desired_kubishime",
  "desired_location",
  "desired_mildWordsBlame",
  "desired_outdoorPlay",
  "desired_photograph",
  "desired_smoking",
  "desired_spanking",
  "desired_married"
];

export const valueCheckForWomen = (womanDoc: Partial<UserWoman>) => {
  const fields = REQUIRED_FIELDS_WOMEN;
  return fields.every((field) => {
    if (!isEmptyValue(womanDoc[field])) {
      return field;
    }
  });
};

export const listenIsAvailableRecommendForWomen = async (
  uid: string,
  setter: any
) => {
  const q = query(collection(db, "UserWomen"), where("uid", "==", uid));
  const querySnapshot = await getDocs(q);
  const check = valueCheckForWomen(querySnapshot.docs[0].data());
  setter(check);
  return check;
};
